module.exports = __webpack_public_path__ + "static/media/pp_regular_paper_straw_green2.67111438.png";